module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promo"
  }, [_c('div', {
    staticClass: "promo_title"
  }, [_c('v-icon', [_vm._v("new_releases")]), _vm._v("프로모션")], 1), _vm._v(" "), (_vm.promoCnt !== 0) ? _vm._l((_vm.promotions), function(promo, n) {
    return _c('div', {
      key: n,
      staticClass: "promo_content"
    }, [_c('img', {
      attrs: {
        "src": promo.banner_url,
        "alt": "promotion"
      },
      on: {
        "click": function($event) {
          return _vm.clickHandler($event, promo.landing_url)
        }
      }
    })])
  }) : _vm._e(), _vm._v(" "), (_vm.promoCnt === 0) ? [_vm._m(0)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promocontents"
  }, [_c('img', {
    attrs: {
      "src": "https://interview.interworksmedia.co.kr/interview/static/img/inteplay_launching.jpg",
      "alt": "down"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09890fd4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainScreen/Promotion.vue
// module id = 829
// module chunks = 1